import { Component, OnInit, Input, OnDestroy, HostListener } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { UserService } from 'app/services/user/user.service';
import { Subscription } from 'rxjs';
import { Consent, ConsentType } from 'app/model/user/consent-model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

const DEFAULT_PURPOSE_CHECKBOX = true;
@Component({
  selector: 'act-dialog-terms-and-conditions',
  templateUrl: './dialog-terms-and-conditions.component.html',
  styleUrls: ['./dialog-terms-and-conditions.component.scss']
})
export class DialogTermsAndConditionsComponent implements OnInit, OnDestroy {
  @Input() userId: number;
  @Input() isShowSubmit = false;
  @Input() consentType;

  _consent: Consent;
  get consent(): Consent {
      return this._consent;
  }
  @Input() set consent(consent: Consent) {
    this._consent = consent;
    this.addPurposes();
    setTimeout(() => this.onResize(), 0);
  }

  form: FormGroup;
  public consentTypeConst = ConsentType;

  private updateUserConsentSubscription: Subscription;

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    document.documentElement.style.setProperty('--dialog-filter-vh', `${window.innerHeight * 0.01}px`);
    if (document.getElementById('dialog-terms-and-condition-footer') && document.getElementById('dialog-terms-and-condition-title')) {
      document.documentElement.style.setProperty('--title-height', `${document.getElementById('dialog-terms-and-condition-title').clientHeight}px`);
      document.documentElement.style.setProperty('--footer-height', `${document.getElementById('dialog-terms-and-condition-footer').clientHeight}px`);
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event?: KeyboardEvent) {
    event.stopImmediatePropagation();
    return false;
  }

  constructor(
    public dialogRef: MdDialogRef<any>,
    private userService: UserService,
    private formBuilder: FormBuilder,
  ) {
    this.form = this.formBuilder.group({
      purposes: new FormArray([])
    });
  }

  get purposesFormArray() {
    return this.form.controls.purposes as FormArray;
  }

  ngOnInit() {
    this.onResize();
  }

  ngOnDestroy() {
    this.updateUserConsentSubscription && this.updateUserConsentSubscription.unsubscribe();
  }

  addPurposes() {
    this.consent.purposes.forEach(() => this.purposesFormArray.push(new FormControl(DEFAULT_PURPOSE_CHECKBOX)));
  }

  handleCloseDialog() {
    this.dialogRef.close();
  }

  submit() {
    const selectedPurposeIds = this.form.value.purposes
      .map((checked, i) => checked ? this.consent.purposes[i].purposeId : null)
      .filter(v => v !== null);
    this.updateUserConsentSubscription && this.updateUserConsentSubscription.unsubscribe();
    this.updateUserConsentSubscription = this.userService.updateConsent(this.userId, this.consent.consentId, selectedPurposeIds).subscribe(
      (res) => { this.dialogRef.close(); },
      (error) => { this.dialogRef.close(); }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-terms-and-conditions/dialog-terms-and-conditions.component.ts